var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h1',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.$t('PAGE_TITLE')))]),_c('Header'),_c('router-view'),_c('portal-target',{attrs:{"name":"answers-outlet"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }